// icons
import { MdEvent, MdScience, MdBloodtype, MdMonitorHeart, MdFavorite, MdLocalHospital, MdSchool, MdTv, MdHowToReg, MdPersonAdd, MdMonitorWeight, MdFavoriteBorder, MdHealthAndSafety } from "react-icons/md";

const circuito = {
    id: 'circuito-group',
    type: 'group',
    roles: [1,100,300],
    breadcrumbs: false,
    children: [
      {
        id: 'circuito',
        title: "Circuito",
        type: 'collapse',
        icon: MdEvent,
        children: [
          {
            id: 'checkin-beneficiario',
            title: "Check-in Beneficiario",
            type: 'item',
            breadcrumbs: false,
            icon: MdHowToReg,
            url: '/circuito/checkin-beneficiario',
          },
          {
            id: 'checkin-voluntario',
            title: "Check-in Voluntario",
            type: 'item',
            breadcrumbs: false,
            icon: MdPersonAdd,
            url: '/circuito/checkin-voluntario',
          },
          {
            id: 'estaciones-pruebas',
            title: "Estaciones de Pruebas",
            type: 'collapse',
            breadcrumbs: false,
            icon: MdScience,
            children: [
              {
                id: 'sv-somatometria',
                title: "SV y Somatometría",
                type: 'item',
                breadcrumbs: false,
                icon: MdMonitorWeight,
                url: '/circuito/estaciones-pruebas/sv-somatometria'
              },
              {
                id: 'signos-vitales',
                title: "Signos Vitales",
                type: 'item',
                breadcrumbs: false,
                icon: MdFavoriteBorder,
                url: '/circuito/estaciones-pruebas/signos-vitales'
              },
              {
                id: 'muestras-sanguineas',
                title: "Muestras Sanguíneas",
                type: 'item',
                breadcrumbs: false,
                icon: MdBloodtype,
                url: '/circuito/estaciones-pruebas/muestras-sanguineas'
              },
              {
                id: 'electrocardiograma',
                title: "Electrocardiograma",
                type: 'item',
                breadcrumbs: false,
                icon: MdMonitorHeart,
                url: '/circuito/estaciones-pruebas/electrocardiograma'
              },
              {
                id: 'ecocardiograma',
                title: "Ecocardiograma",
                type: 'item',
                breadcrumbs: false,
                icon: MdFavorite,
                url: '/circuito/estaciones-pruebas/ecocardiograma'
              },
              {
                id: 'evaluacion-cardiovascular',
                title: "Evaluación Cardiovascular",
                type: 'item',
                breadcrumbs: false,
                icon: MdLocalHospital,
                url: '/circuito/estaciones-pruebas/evaluacion-cardiovascular'
              },
              {
                id: 'sesion-platicas',
                title: "Sesión de Pláticas",
                type: 'item',
                breadcrumbs: false,
                icon: MdSchool,
                url: '/circuito/estaciones-pruebas/sesion-platicas'
              },
              {
                id: 'curso-rcp',
                title: "Curso RCP",
                type: 'item',
                breadcrumbs: false,
                icon: MdHealthAndSafety,
                url: '/circuito/estaciones-pruebas/curso-rcp'
              }
            ]
          },
          {
            id: 'monitor',
            title: "Monitor",
            type: 'item',
            breadcrumbs: false,
            icon: MdTv,
            url: '/circuito/monitor',
            roles: [1,100,300],
          },
          
        ]
      }
    ]
};

export default circuito;
